import { MouseEvent, ReactElement } from 'react'

import GoogleIcon from 'src/Assets/Svg/Google.svg?react'
import { AuthOutlineButton } from 'src/Components/Buttons/AuthOutlineButton'

export type GoogleButtonLabel = 'Log in with Google' | 'Continue with Google'

export interface GoogleButtonProps {
  label: GoogleButtonLabel
  loading?: boolean
  disabled?: boolean
  onClick?: (event: MouseEvent<HTMLButtonElement>) => void
  className?: string
}

export const GoogleAuthButton = ({
  label,
  loading,
  disabled,
  onClick,
  className,
}: GoogleButtonProps): ReactElement => (
  <AuthOutlineButton
    icon={<GoogleIcon />}
    label={label}
    loading={loading}
    disabled={disabled}
    onClick={onClick}
    className={className}
  />
)
